<template>
  <div>
    <header class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="m-0">Top Detections</h5>
      <p class="x-small text-muted m-0">
        <span v-if="$apollo.loading && !this.detections.totalCount">Loading...</span>
        <span v-else>Species detected at {{ detections.totalCount }} stations.</span>
      </p>
    </header>

    <div class="species-soundscapes">
      <div v-for="detection in detections.nodes" :key="detection.id">
        <Soundscape :soundscape="detection.soundscape" :detection="detection" :showNavigator="false" />
      </div>
    </div>

    <ul class="pagination justify-content-center mt-4" v-if="showPagination">
      <PageLink @click="loadPreviousPage" :disabled="!detections.pageInfo.hasPreviousPage">Previous</PageLink>
      <PageLink @click="loadNextPage" :disabled="!detections.pageInfo.hasNextPage">Next</PageLink>
    </ul>
  </div>
</template>

<script>
import PageLink from './PageLink'
import Soundscape from './Soundscape'

import SpeciesTopDetectionsQuery from 'queries/SpeciesTopDetections.graphql'

const PER_PAGE = 10

export default {
  props: {
    species: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pageOptions: { first: PER_PAGE },
      detections: {}
    }
  },

  methods: {
    loadNextPage () {
      this.pageOptions = {
        first: PER_PAGE,
        after: this.detections.pageInfo.endCursor
      }
    },

    loadPreviousPage () {
      this.pageOptions = {
        last: PER_PAGE,
        before: this.detections.pageInfo.startCursor
      }
    }
  },

  computed: {
    showPagination () {
      const pageInfo = this.detections.pageInfo
      return pageInfo && (pageInfo.hasNextPage || pageInfo.hasPreviousPage)
    }
  },

  apollo: {
    detections: {
      query: SpeciesTopDetectionsQuery,

      variables () {
        return {
          id: this.species.id,
          ...this.pageOptions
        }
      },

      update: data => data.species.topDetections
    }
  },

  components: {
    PageLink,
    Soundscape
  }
}
</script>
